module.exports = __webpack_public_path__ + "static/media/exampleFormStepOne.dec5531c.pdf";